import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { href: '/', label: '首页' },
  { href: '/categories', label: '服务分类' },
  { href: '/articles', label: '体育资讯' },
  { href: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link
            to="/"
            className="flex items-center gap-2.5 cursor-pointer whitespace-nowrap"
          >
            <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-basketball-line text-background-50 text-lg"></i>
            </div>
            <span className={`text-lg font-semibold font-heading tracking-wide ${scrolled ? 'text-foreground-900' : 'text-background-50'}`}>
              云开体育
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.href;
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`relative px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                    isActive
                      ? scrolled
                        ? 'text-primary-600 bg-primary-100/80'
                        : 'text-background-50 bg-white/20'
                      : scrolled
                        ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                        : 'text-background-50/85 hover:text-background-50 hover:bg-white/15'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="tel:400-888-6666"
              className={`flex items-center gap-2 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                scrolled ? 'text-foreground-600 hover:text-primary-600' : 'text-background-50/80 hover:text-background-50'
              }`}
            >
              <i className="ri-phone-line"></i>
              400-888-6666
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer transition-colors ${
              scrolled ? 'text-foreground-700 hover:bg-background-200' : 'text-background-50 hover:bg-white/20'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-6 py-3 flex flex-col gap-1">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.href;
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    isActive
                      ? 'text-primary-600 bg-primary-100/80'
                      : 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <a
              href="tel:400-888-6666"
              className="px-4 py-2.5 rounded-lg text-sm font-medium text-foreground-700 hover:text-primary-600 whitespace-nowrap cursor-pointer flex items-center gap-2"
            >
              <i className="ri-phone-line"></i>
              400-888-6666
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}